<div class="apply-stepper-body">
  <div class="apply-stepper-form">
    <ng-container
      *ngFor="let step of fields; let index = index; let last = last">
      <ng-container
        *ngTemplateOutlet="
          selectedIndex !== index ? headerCollapsed : headerExpanded
        "></ng-container>

      <ng-template #headerCollapsed>
        <div class="card-header collapse">
          <h5>
            {{ index + 1 + '. ' + step.props?.label }}
          </h5>
          <div class="icon" *ngIf="shouldShowStepIcon(index)">
            <i class="fa-solid fa-angle-down"></i>
          </div>
          <div
            class="d-flex justify-content-between align-items-center w-auto gap-3"
            *ngIf="shouldShowEditButton(index)">
            <div
              role="button"
              (click)="goBack(index)"
              class="icon rounded-3 py px-3 w-auto"
              [ngStyle]="{ height: 'unset', width: 'unset' }">
              {{ 'Edit' | translate }}
            </div>
            <div
              class="bg-success text-white rounded-circle text-center"
              [style.width.px]="28"
              [style.height.px]="28">
              <i class="fa fa-check pt-2"></i>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #headerExpanded>
        <div class="card-header">
          <h5>
            {{ index + 1 + '.' + step.props?.label }}
          </h5>
          <span
            >{{ 'Fields marked with' | translate }}
            <span class="text-danger">*</span>
            {{ 'are mandatory.' | translate }}</span
          >
        </div>
      </ng-template>
      <div class="card" [ngClass]="getStepClasses(index)">
        <div
          [ngbCollapse]="isStepCollapsed(index)"
          class="{{ 'step_' + index }}">
          <div class="card-body px-0 py-0">
            <div class="px-4 formly-field-preview">
              <formly-field [field]="step" class="px-3"></formly-field>
            </div>
            <!-- Validation Errors Display -->
            <div
              *ngIf="validationErrors.length > 0"
              class="validation-errors mx-4 mt-3">
              <div class="error-title mb-2 text-danger">
                {{
                  'Please fix the following errors before continuing:'
                    | translate
                }}
              </div>
              <ul class="mb-0 text-danger error-list">
                <li *ngFor="let err of validationErrors">
                  <strong>{{ err.label }}</strong>
                  <ul>
                    <li *ngFor="let msg of err.messages">{{ msg }}</li>
                  </ul>
                </li>
              </ul>
            </div>
            <div
              class="d-flex gap-2 d-md-flex justify-content-end action-buttons px-4 py-3 w-100">
              <button
                *ngIf="shouldShowSaveDraftButton(last)"
                [disabled]="draftIsSaving"
                type="button"
                class="btn btn-default next btn-draft"
                (click)="handleDraft(step)">
                {{ draftButtonText | translate }}
              </button>
              <!-- Debug info -->
              <!-- last: {{ last }}, isInNestedContext: {{ isInNestedContext }}, shouldShow: {{ shouldShowContinueButton(last) }} -->
              <button
                *ngIf="!last && shouldShowContinueButton(false)"
                type="button"
                class="btn btn-primary next"
                (click)="onNext(step)">
                {{ 'Continue' | translate }}
              </button>
              <button
                *ngIf="last && shouldShowContinueButton(true)"
                type="button"
                class="btn btn-primary next"
                (click)="onNext(step)">
                {{ step.props?.["nextButtonText"] ? step.props?.["nextButtonText"] : 'Continue' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Hidden submit button that will be clicked programmatically for service journeys -->
  <button #hiddenSubmitButton type="submit" style="display: none">
    Submit
  </button>
</div>
